import axios from "axios";
import { authService } from "../services/auth.service";

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

instance.interceptors.request.use((config) => {
  const token = authService.getAccessToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

instance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // Don't retry if:
    // 1. Already retried
    // 2. Request is to /auth/refresh (prevent infinite loop on refresh endpoint itself)
    // 3. Request is to /auth/login or /auth/logout
    const isAuthEndpoint = originalRequest.url?.includes('/auth/refresh') ||
                           originalRequest.url?.includes('/auth/login') ||
                           originalRequest.url?.includes('/auth/logout');

    if (error.response?.status === 401 && !originalRequest._retry && !isAuthEndpoint) {
      originalRequest._retry = true;
      try {
        const { accessToken } = await authService.refreshAuthToken();
        if (accessToken) {
          axios.defaults.headers.common["Authorization"] = `Bearer ${accessToken}`;
          return instance(originalRequest);
        }
      } catch (e) {
        // Refresh failed, clear tokens and redirect
        // The redirect is handled in refreshAuthToken, so just return rejected promise
        return Promise.reject(e);
      }
    }
    return Promise.reject(error);
  }
);

export default instance;